import { render } from "./ReservationCard.vue?vue&type=template&id=58dd0193&scoped=true"
import script from "./ReservationCard.vue?vue&type=script&lang=ts"
export * from "./ReservationCard.vue?vue&type=script&lang=ts"

import "./ReservationCard.vue?vue&type=style&index=0&id=58dd0193&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58dd0193"

export default script